import React from 'react';
import PropTypes from 'prop-types';

const Ellipsis = ({ fill, theme, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99977 5.48305C9.34783 5.48303 9.68802 5.3795 9.9771 5.18565C10.2662 4.99179 10.4911 4.71636 10.6232 4.39436C10.7554 4.07237 10.7888 3.71835 10.7192 3.37731C10.6497 3.03627 10.4803 2.72362 10.2326 2.4791C9.98487 2.23458 9.67006 2.06923 9.32815 2.00408C8.98625 1.93892 8.63269 1.9769 8.31243 2.11319C7.99216 2.24948 7.71965 2.47792 7.52954 2.76947C7.33943 3.06103 7.24031 3.40252 7.24477 3.75055C7.25069 4.2121 7.4382 4.65273 7.76669 4.97701C8.09518 5.30128 8.53819 5.48309 8.99977 5.48305ZM8.99977 7.24555C8.65267 7.24555 8.31335 7.34848 8.02475 7.54132C7.73614 7.73417 7.5112 8.00826 7.37836 8.32894C7.24553 8.64963 7.21078 9.0025 7.2785 9.34294C7.34621 9.68337 7.51336 9.99608 7.7588 10.2415C8.00424 10.487 8.31695 10.6541 8.65739 10.7218C8.99783 10.7895 9.3507 10.7548 9.67138 10.622C9.99207 10.4891 10.2662 10.2642 10.459 9.97558C10.6518 9.68697 10.7548 9.34766 10.7548 9.00055C10.7548 8.5351 10.5699 8.08871 10.2407 7.75958C9.91162 7.43045 9.46523 7.24555 8.99977 7.24555ZM8.99977 12.4956C8.65267 12.4956 8.31335 12.5985 8.02475 12.7913C7.73614 12.9842 7.5112 13.2583 7.37836 13.5789C7.24553 13.8996 7.21078 14.2525 7.2785 14.5929C7.34621 14.9334 7.51336 15.2461 7.7588 15.4915C8.00424 15.737 8.31695 15.9041 8.65739 15.9718C8.99783 16.0395 9.3507 16.0048 9.67138 15.872C9.99207 15.7391 10.2662 15.5142 10.459 15.2256C10.6518 14.937 10.7548 14.5977 10.7548 14.2506C10.7489 13.789 10.5613 13.3484 10.2329 13.0241C9.90437 12.6998 9.46135 12.518 8.99977 12.5181V12.4956Z"
      fill={fill || theme.COLORS.bodyLight}
    />
  </svg>
);

Ellipsis.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Ellipsis;
